import axios from "../../service/index"
import React, { Component } from "react"
import {Form, Input, Select, Divider, Button, Tag, message, Table, Modal,} from 'antd'
import UploadQiniu from '../../commponents/uploadQiniu/index'
import ImgQiniu from '../../commponents/imgQiniu/index'
import "./openclass.less"
const FormItem = Form.Item;
const {Option} = Select;
class CreateSubject extends Component{
  constructor(props) {
		super(props)
    this.state = {
      modelTitle: '新建',
      subjectName: '',
      subjectIcon: {},
      zsCourseId: '',
      optionList: [],
      advPic: {},
      name: '',
      subject: '',
      qiuniuUrl: '',
      employCourseId: '',
      isEdit: true,
      labelName: '',
      tagList: [],
      relevenceModel: false,
      linkType: '',
      linkUrl: '',
      infoObj: {},
      employName: '',
      employSubjectid: '',
      subjectId: '',
      tableData: [],
      selTableData: [],
      subjectOption: [],
      selectedRowKeys: [],
      columns: [{
        title: '课程ID',
        dataIndex: 'id',
        key: 'id',
				align: 'center',
      },{
        title: '课程名称',
				dataIndex: 'name',
        key: 'name',
				align: 'center',
				ellipsis: true,
      },{
        title: '学科',
				dataIndex: 'subjectName',
				key: 'subjectName',
				align: 'center',
				ellipsis: true,
      },{
        title: '操作',
				align: 'center',
				render: (record) => <span className="danger-btn" onClick={() => {this.delEmploy(record)}}>取消关联</span>
      }],
      tableColumns: [{
        title: '课程ID',
				dataIndex: 'id',
				key: 'id',
        width: '100px',
				align: 'center',
      },{
        title: '课程名称',
				dataIndex: 'name',
				key: 'name',
				ellipsis: true,
      },{
        title: '学科',
				dataIndex: 'subjectName',
				key: 'subjectName',
				align: 'center',
				ellipsis: true,
        width: '200px'
      }]
    }
  }
  componentDidMount() {
    let local = this.props.location.state
    this.getZsCourseList()
    this.getSubjectList()
    this.getEmployList()
    if(local.id){
      this.setState({
        modelTitle: local.courseTitle,
        subjectId: local.id
      })
      this.detailInfo(local.id)
    }
  }
  getZsCourseList() {
		axios.get('subjectController/getZsCourseList').then( res => {
			if(res.data.code === '200') {
				let arr = res.data.data
				this.setState({
					optionList: arr
				})
			}
		})
	}
  getSubjectList() {
    axios.get('subjectController/subjects/2').then( res => {
			if(res.data.code === '200') {
				let arr = res.data.data
				this.setState({
					subjectOption: arr
				})
			}
		})
  }
  detailInfo(id) {
    axios.get(`subjectController/info/${id}`).then( res => {
      if(res.data.code === '200') {
        // console.log(res.data.data)
        let arr = res.data.data
        this.setState({
          infoObj: arr,
          id: arr.id,
          tagList: arr.labels||[],
          linkUrl: arr.linkUrl||'',
          appid: arr.appid||'',
          linkType: arr.linkType||'',
          employCourseId: arr.employCourseId||'',
          selTableData: arr.employCourse?[arr.employCourse]:[],
          selectedRowKeys: [arr.employCourseId]||[],
          subjectIcon: {
            uid: arr?.uploadUid,
            type: arr?.uploadType,
            url: arr.pic,
            name: arr.name+'图标'
          },
          advPic: {
            uid: arr?.uploadUid,
            type: arr?.uploadType,
            url: arr?.advPic,
            name: arr.name+'封面'
          }
        })
        this.props.form.setFieldsValue({
          'employCourseId': this.state.selectedRowKeys[0]
        })
      }
    })
  }
  // 关联课程
  getEmployList() {
    axios.post('subjectController/getEmployCourses',{
      name: this.state.employName,
      subjectId: this.state.employSubjectid
    }).then( res => {
      if(res.data.code === '200') {
        let arr = res.data.data
        let selArray = arr.filter(v => v.checked === true)
        this.setState({
          tableData: arr,
          selectedRowKeys: [selArray[0]?.courseId]||[],
          selTableData: selArray
        })
      }
    })
  }
  handleOk = (e) => {
    e.preventDefault();
		this.props.form.validateFields((err, values) => {
			console.log(values, this.state.selectedRowKeys)
			if (!err) {
        let params = {
          id: this.state.modelTitle === '编辑' ?this.state.infoObj.id:'',
          employCourseId: this.state.selectedRowKeys[0]||'',
          pic: (values.uploadUrls.url && this.state.modelTitle === '编辑')?this.state.infoObj.pic:this.state.qiuniuUrl+'/'+values.uploadUrls.response.key,
          advPic: (values.advPic.url && this.state.modelTitle === '编辑')?this.state.infoObj.advPic:this.state.qiuniuUrl+'/'+values.advPic.response.key,
          name: values.name,
          uploadType: values.uploadUrls.type,
					uploadUid: values.uploadUrls.uid,
          material: {
            name: values.materialname,
            appid: this.state.appid,
            linkType: this.state.linkType,
            linkUrl: this.state.linkUrl!==2?this.state.linkUrl:'',
            subjectId: values.zsCourseId,
            path: this.state.linkType === 2?this.state.linkUrl:'',
            labels: this.state.tagList||[],
          },
        }
        let url = this.state.modelTitle === '编辑' ? 'subjectController/updateSubject' : 'subjectController/addSubject'
				axios.post(url, params).then(res => {
          if(res.data.code !== '200')return message.error(res.data.msg)
          message.success(this.state.modelTitle+'成功')
          this.props.form.resetFields();
          this.props.history.push('/subjectController')
        })
      }
    })
  }
  relevenceOk() {
    if(this.state.selTableData.length<=0)return message.error('请选择关联课程')
    this.setState({relevenceModel: false})
    this.props.form.setFieldsValue({
      'employCourseId': this.state.selectedRowKeys[0]
    })
  }
  blurLabel(e) {
    if(this.state.tagList.length>=3)return message.error('最多填写3个标签');
      // console.log(e)
      if(e.target.value){
        this.setState({tagList: [...this.state.tagList, e.target.value],labelName: '', isEdit: true})
      }
  }
  closeTag(index) {
    const list = [...this.state.tagList];
    list.splice(index,1);
    this.setState({
      tagList: list
    })
  }
  closeModel = () => {
    this.setState({
      relevenceModel: false
    })
  }
  
  getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
  getAdverUrl = v => {
    this.setState({
      advPic: v
    })
  }
  delEmploy(obj) {
    const updatedItem = this.state.selTableData.filter(item => item.id !== obj.id)
    const updatedKeys = this.state.selectedRowKeys.filter(item => item !== obj.id)
    this.setState({selTableData: updatedItem||[], selectedRowKeys: updatedKeys||[]})
  }
  render() {
    const {modelTitle, selTableData, subjectIcon, selectedRowKeys, employCourseId, advPic, infoObj, isEdit, tagList, labelName, columns, tableData, relevenceModel, tableColumns} = this.state
    const { getFieldDecorator } = this.props.form;
    const rowSelection = {
      type:'radio',
      columnTitle:"选择",
      columnWidth:"40",
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        // console.log(selectedRowKeys)
        this.setState({ selectedRowKeys, selTableData: selectedRows, employCourseId: selectedRowKeys[0]})
      },
      fixed: 'right'
    }
    // console.log(subjectIcon, advPic)
    return (
        <div className="create-subject">
          <div className="header-between">
          <span className="header-name">{modelTitle}学科</span>
          <span className="my-button-txt" onClick={()=>{
              this.props.history.push('/subjectController')
              this.props.form.resetFields();
            }}>返回上一级</span>
          </div>
          <Divider />
          <Form labelCol={{ span: 3 }} wrapperCol={{ span: 12 }} onSubmit={this.handleOk}>
            <FormItem label={"学科名称"} key={0}>
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请输入学科名称!', }],
                initialValue:modelTitle==='编辑'? infoObj.name: ''
              })(
                <Input placeholder='请输入学科名称' allowClear maxLength={50}/>
              )}
            </FormItem>
            <Form.Item label="学科图标" className="uploadUrl" key={9}>
              {getFieldDecorator('uploadUrls', {
                initialValue: modelTitle==='编辑'? subjectIcon: '',
                rules: [{ type: 'object', required: true, message: '请上传学科图标!' }],
              })(
                <UploadQiniu getQiniuUrl ={this.getQiniuUrl } />
              )}
            </Form.Item>
            <Form.Item label="学科广告图" className="advPic" key={10}>
              {getFieldDecorator('advPic', {
                initialValue: modelTitle==='编辑'? advPic: '',
                rules: [{ type: 'object', required: true, message: '请上传学科广告图!' }],
              })(
                <ImgQiniu getQiniuUrl ={this.getQiniuUrl } /> //getAdverUrl
              )}
            </Form.Item>
            <p className="new-title">配套资料设置：</p>
            <FormItem label={"资料名称"} key={3}>
              {getFieldDecorator('materialname', {
                rules: [{ required: true, message: '请输入资料名称!', }],
                initialValue:modelTitle==='编辑'? (infoObj?.materialName): ''
              })(
                <Input placeholder='请输入资料名称' allowClear maxLength={50}/>
              )}
            </FormItem>
            <div className="zip-form">
              <p className="zip-text"><span>*</span> 资料类型: </p>
            <FormItem label="" key={4}>
              {getFieldDecorator('linkType', {
                rules: [{ required: true, message: '请选择'}],
                initialValue:modelTitle==='编辑'? infoObj.linkType: ''
              })(
                  <Select onChange={(val) => {
                    this.setState({
                      linkType: val
                    })
                  }} placeholder="请选择资料类型" className="zip-width">
                    <Option value={0}>小程序内部链接</Option>
                    <Option value={1}>H5链接</Option>
                    <Option value={2}>第三方小程序链接</Option>
                  </Select>
              )}
            </FormItem>
            {this.state.linkType === 2?<FormItem label="">
              {getFieldDecorator('appid', {
                rules: [{ required: true, message: '请输入appId', }],
                initialValue:modelTitle==='编辑'? infoObj.appid: ''
              })(
                  <Input onChange={(e) => {this.setState({appid: e.target.value})}} className="zip-width" placeholder='请输入AppId' allowClear maxLength={50}/>
              )}
            </FormItem>:''}
            <FormItem label="">
              {getFieldDecorator('linkUrl', {
                rules: [{ required: true, message: '请输入资料链接'}],
                initialValue:modelTitle==='编辑'? infoObj.linkUrl: ''
              })(
                <Input placeholder='请输入链接' onChange={(e) => {this.setState({linkUrl: e.target.value})}} allowClear />
              )}
            </FormItem>
            </div>
            <Form.Item label={"资料标签"} key={5}>
              {getFieldDecorator('labels', {
                initialValue:modelTitle==='编辑'? infoObj.labels: ''
              })(
                <div className="zip-label">
                  {isEdit?<Button onClick={()=> {if(this.state.tagList?.length<3){this.setState({isEdit: false})}}}>+标签({tagList?.length||0}/3)</Button>:
                  <Input className="label-name" value={labelName} placeholder='请输入标签名称' maxLength={6} onChange={(e)=>{
                    this.setState({
                      labelName: e.target.value
                    })
                  }} onBlur={(e) => {this.blurLabel(e)}} />}
                  <div className="list">
                    {tagList.map((v,i) => {
                      return (
                        <Tag color="blue" key={i} closable onClose={() => this.closeTag(i)}>{v}</Tag>
                      )
                    })}
                  </div>
                </div>
              )}
            </Form.Item>
            
            <Form.Item label="对应招生学科" key={6}>
              {getFieldDecorator('zsCourseId', {
                rules: [{ required: true, message: '请选择对应学科' }],
                initialValue:modelTitle==='编辑'? infoObj.zsCourseId: ''
              })(
                <Select
                  placeholder="请选择对应学科"
                >
                  {this.state.optionList.map(item=>{
                    return (<Option key={item.id+item.name} value={item.id}>{item.name}</Option>)
                  })}
                </Select>
              )}
            </Form.Item>

            <Form.Item label={"关联就业课"} key={7}>
              {getFieldDecorator('employCourseId', {
                initialValue: employCourseId||'',
                rules: [{ required: true, message: '请选择关联就业课!'}],
              })(
                <div>
                  <div className="relevance">
                    <Button type="primary" onClick={() => {this.setState({relevenceModel: true})}}>关联课程</Button>
                    <p>只能关联一门课程</p>
                  </div>
                  <Table columns={columns} dataSource={selTableData} rowKey={record => record.id+''} pagination={false} />
                </div>
              )}
            </Form.Item>
            <Form.Item style={{textAlign: 'center', marginLeft: '12%',marginTop: '60px',marginBottom: '60px'}}>
              <Button onClick={() => {this.props.history.push('/subjectController');this.props.form.resetFields();}}>取消</Button>
              <Button style={{ marginLeft: 8 }} type="primary" htmlType="submit">确定</Button>
						</Form.Item>
          </Form>
          <Modal title="关联课程" width={800} visible={relevenceModel} onOk={()=>{this.relevenceOk()}} onCancel={this.closeModel}>
            <div style={{display: 'flex',alignItems: 'center', marginBottom: '20px'}}>
              <span>课程名称：</span><Input allowClear value={this.state.employName} style={{ width: '200px', height: '40px', marginRight: '20px' }} 
              placeholder="课程名称"
              onChange={(e)=>{
                this.setState({
                  employName: e.target.value
                })
              }}
              ></Input>
              <span>学科：</span>
              <Select placeholder="请选择" value={this.state.employSubjectid} allowClear style={{ width: 140,  marginRight: '10px' }} onChange={(value) => {
                this.setState({
                  employSubjectid: value
                })
                }}>
                  <Option value={""}>全部</Option>
                  {this.state.subjectOption.map(item => {
                    return (<Option key={item.subjectId + item.subjectName} value={item.subjectId}>{item.subjectName}</Option>)
                  })}
              </Select>
              <Button className='my-button-primary' style={{marginLeft: '20px', marginRight: '20px' }} onClick={() => {
                this.getEmployList()
              }} type='primary'>搜索</Button>
              <span className='my-button-txt' onClick={() => {
                this.setState({
                  employName: '',
                  employSubjectid: ''
                }, () => {
                  this.getEmployList()
                })
              }} type='primary'>重置</span>
            </div>
            <Table columns={tableColumns} rowSelection={rowSelection} dataSource={tableData} rowKey={record => record.id} scroll={{y: 500}} pagination={false} />
          </Modal>
        </div>
    )
  }
}
export default Form.create()(CreateSubject)